@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@300;400;500;700&family=Noto+Serif+SC:wght@400;500;600;700&family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400&display=swap');
@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --font-body: 'Noto Sans SC', ui-sans-serif, system-ui, sans-serif;
  --font-heading: 'Noto Serif SC', 'Cormorant Garamond', ui-serif, Georgia, serif;
  --font-label: 'Noto Sans SC', ui-sans-serif, system-ui, sans-serif;

  /* background — 宣纸白 */
  --background-50: 0.99 0.006 85;
  --background-100: 0.968 0.012 82;
  --background-200: 0.932 0.018 80;
  --background-300: 0.882 0.024 78;
  --background-400: 0.82 0.03 76;
  --background-500: 0.74 0.034 74;
  --background-600: 0.64 0.034 72;
  --background-700: 0.52 0.032 70;
  --background-800: 0.4 0.028 68;
  --background-900: 0.3 0.024 66;
  --background-950: 0.22 0.02 64;

  /* foreground — 墨 */
  --foreground-50: 0.96 0.006 75;
  --foreground-100: 0.9 0.01 72;
  --foreground-200: 0.82 0.014 70;
  --foreground-300: 0.72 0.016 68;
  --foreground-400: 0.62 0.018 66;
  --foreground-500: 0.52 0.02 64;
  --foreground-600: 0.44 0.022 62;
  --foreground-700: 0.36 0.022 60;
  --foreground-800: 0.29 0.022 58;
  --foreground-900: 0.24 0.021 56;
  --foreground-950: 0.19 0.02 55;

  /* primary — 朱砂红 */
  --primary-50: 0.97 0.018 35;
  --primary-100: 0.925 0.045 35;
  --primary-200: 0.858 0.085 34;
  --primary-300: 0.762 0.125 34;
  --primary-400: 0.66 0.155 34;
  --primary-500: 0.565 0.168 34;
  --primary-600: 0.495 0.158 33;
  --primary-700: 0.425 0.14 32;
  --primary-800: 0.36 0.118 31;
  --primary-900: 0.3 0.098 30;
  --primary-950: 0.24 0.075 30;

  /* accent — 琥珀金 */
  --accent-50: 0.975 0.026 82;
  --accent-100: 0.938 0.058 80;
  --accent-200: 0.888 0.088 78;
  --accent-300: 0.83 0.115 76;
  --accent-400: 0.782 0.132 75;
  --accent-500: 0.735 0.142 74;
  --accent-600: 0.66 0.132 72;
  --accent-700: 0.558 0.112 70;
  --accent-800: 0.462 0.092 68;
  --accent-900: 0.378 0.072 66;
  --accent-950: 0.3 0.055 64;

  /* secondary — 青绿 */
  --secondary-50: 0.97 0.022 155;
  --secondary-100: 0.932 0.042 155;
  --secondary-200: 0.872 0.062 155;
  --secondary-300: 0.782 0.082 155;
  --secondary-400: 0.685 0.092 155;
  --secondary-500: 0.6 0.09 155;
  --secondary-600: 0.52 0.08 154;
  --secondary-700: 0.44 0.07 153;
  --secondary-800: 0.36 0.058 152;
  --secondary-900: 0.3 0.048 152;
  --secondary-950: 0.24 0.038 150;
}

html {
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
  font-family: var(--font-body);
  background-color: oklch(var(--background-50));
  color: oklch(var(--foreground-900));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@layer base {
  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-heading);
  }
}

/* 滚动出现动效 */
.reveal {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.9s cubic-bezier(0.22, 1, 0.36, 1), transform 0.9s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: opacity, transform;
}
.reveal.is-visible {
  opacity: 1;
  transform: none;
}

@keyframes nomoFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-14px); }
}
.animate-nomo-float {
  animation: nomoFloat 7s ease-in-out infinite;
}

@keyframes nomoPulse {
  0%, 100% { opacity: 0.45; transform: scale(1); }
  50% { opacity: 0.85; transform: scale(1.08); }
}
.animate-nomo-pulse {
  animation: nomoPulse 5s ease-in-out infinite;
}

@keyframes nomoDrift {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
.animate-nomo-drift {
  animation: nomoDrift 32s linear infinite;
}

/* 表单防机器人隐藏字段（非内联、非通用工具类） */
.nomo-aux-field {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  html { scroll-behavior: auto; }
  .reveal { opacity: 1; transform: none; transition: none; }
  .animate-nomo-float,
  .animate-nomo-pulse,
  .animate-nomo-drift { animation: none; }
}